// @ts-strict-ignore
import { Box } from 'components/Box';
import { CmsApiTwoTilesBlockData } from 'modules/cms/api/types/CmsApiTwoTiles';

import { CmsTwoTilesBlockTile } from './CmsTwoTilesBlockTile';

type Props = {
  data: CmsApiTwoTilesBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsTwoTilesBlock({
  data: {
    tileOneHeadline,
    tileOneText,
    tileOneButtonText,
    tileOneButtonUrl,
    tileTwoHeadline,
    tileTwoText,
    tileTwoButtonText,
    tileTwoButtonUrl,
  },
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Box
      display="flex"
      width="100%"
      alignItems="stretch"
      flexDirection={['column', 'column', 'row']}
      justifyContent="center"
    >
      <CmsTwoTilesBlockTile
        dataQaPrefix="tile-one"
        headline={tileOneHeadline}
        text={tileOneText}
        buttonText={tileOneButtonText}
        buttonUrl={tileOneButtonUrl}
        blockIndex={blockIndex}
        pageUpdated={pageUpdated}
      />

      <CmsTwoTilesBlockTile
        mt={['20px', null, 0]}
        ml={[null, null, '40px']}
        dataQaPrefix="tile-two"
        headline={tileTwoHeadline}
        text={tileTwoText}
        buttonText={tileTwoButtonText}
        buttonUrl={tileTwoButtonUrl}
        blockIndex={blockIndex}
        pageUpdated={pageUpdated}
      />
    </Box>
  );
}
